// import PromotionsConfig from '@/features/promotions/config.json';
//
// export const INTERNATIONAL_OFFERS_ENABLED_COUNTRIES = PromotionsConfig.allowed_fallback_to_foreign_offers;

// as an inbetween step, we need to decouple this configuration from the BE,
// so we can activate BE with it for development and don't switch it live on PROD.
export const INTERNATIONAL_OFFERS_ENABLED_COUNTRIES = [
	'AU',
	'CA',
	'DE',
	'ES',
	'FR',
	'IT',
	'JP',
	'US',
	// countries from before
	'BH',
	'DO',
	'ZW',
	'NI',
	'BO',
	'HN',
	'QA',
	'ZA',
	'UA',
	'SI',
	'CZ',
	'JO',
	'AZ',
	'MT',
	'MU',
	'OM',
	'GH',
	'MD',
	'TT',
	'VE',
	'UG',
	'BY',
	'BS',
	'AG',
	'CV',
	'BZ',
	'BM',
	'NE',
	'HU',
	'SV',
	'LB',
	'FJ',
	'MZ',
	'LT',
	'PH',
	'TH',
	'GB',
	'TR',
	'SA',
	'IL',
	'LT',
	'SK',
	'LV',
	'LU',
	'EE',
	'RU',
	'KR',
	'AE',
	'BG',
	'EG',
];
